import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withToast } from "../contexts/toastr.context";
import moment from "moment";

import leftIcon from "../_assets/images/left_icon.png";
import surveyIconImg from "../_assets/images/survey-icon.png";
import surveyCheckIcon from "../_assets/images/survey-check.png";
import surveyCalendarIcon from "../_assets/images/survey-calendar.png";
import { Button } from "../_components/button.component";
import { SurveysService } from "../_service/surveys.service";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../_components/loader.component";

export const SURVEY_ROUTE = "/survey";

function SurveyPageComponent({ user, history }) {
  const [surveysTemplates, setSurveysTemplates] = useState([
    { name: "Likelihood of Turnover", value: "likelihood_of_turnover" },
    { name: "Professional Satisfaction", value: "professional_satisfaction" },
    { name: "Overall Wellbeing", value: "overall_wellbeing" },
    { name: "Burnout", value: "burnout" },
    { name: "Stress & Anxiety", value: "stress_and_anxiety" },
    { name: "Sleep", value: "sleep" },
  ]);
  const [surveyResults, setSurveyResults] = useState([]);
  const [isSurveyLoading, setIsSurveyLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreRecords, setHasMoreRecords] = useState(true);
  const [selectedTemplates, setSelectedTemplates] = useState({
    likelihood_of_turnover: false,
    professional_satisfaction: false,
    overall_wellbeing: false,
    burnout: false,
    stress_and_anxiety: false,
    sleep: false,
  });

  useEffect(() => {
    getSurveysData();
  }, []);

  /**
   * handleTemplateSelection function
   * @param {*} template
   * Boolean value for template is changed and state is updated
   */
  const handleTemplateSelection = (template) => {
    let allTemplates = JSON.parse(JSON.stringify(selectedTemplates));
    allTemplates[template] = !allTemplates[template];
    setSelectedTemplates(allTemplates);
  };

  const getSurveysData = () => {
    setIsSurveyLoading(true);
    SurveysService.getSurveys(user, {
      page: currentPage,
    })
      .then((resp) => {
        setIsSurveyLoading(false);
        setCurrentPage(currentPage + 1);
        if (resp.survey.length >= 1) {
          setCurrentPage(currentPage + 1);
        } else {
          setHasMoreRecords(false);
        }
        setSurveyResults([...surveyResults, ...resp.survey]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchMoreData = () => {
    SurveysService.getSurveys(user, {
      page: currentPage,
    })
      .then((resp) => {
        if (resp.survey.length >= 1) {
          setCurrentPage(currentPage + 1);
        } else {
          setHasMoreRecords(false);
        }
        setSurveyResults([...surveyResults, ...resp.survey]);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container survey-page-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img src={leftIcon} alt="" onClick={() => history.push("/")} />
        <span
          className="ml-3 text-xl home-text t-grey"
          onClick={() => history.push("/")}>
          Home
        </span>
      </div>
      <div className="flex justify-between">
        <div
          className="bg-white card px-11 py-9 relative rounded-lg mr-4 new-assessent-container"
          style={{ height: "350px", width: "60%" }}>
          <div>
            <div className="flex justify-between">
              <p className="font-bold text-lg text-primary">New Assessment</p>
            </div>
            <div className="flex justify-between mt-5">
              <p className="font-bold text-lg t-grey">
                What would you like assess? Use our prepopulated templates:
              </p>
            </div>
            <div className="mt-4">
              <div className="grid grid-cols-2">
                {surveysTemplates.map((surveyTemplate, index) => {
                  return (
                    <div
                      className={`border m-1 p-2 rounded t-grey flex ${
                        selectedTemplates[surveyTemplate.value]
                          ? "selected-template"
                          : ""
                      }`}
                      key={index}>
                      <input
                        type="checkbox"
                        className="mr-2 template-checkbox cursor-pointer "
                        onClick={(e) =>
                          handleTemplateSelection(surveyTemplate.value)
                        }
                      />
                      <span className="t-grey">{surveyTemplate.name}</span>
                    </div>
                  );
                })}
              </div>
              <div className="mt-4 text-right">
                <Button
                  label="+ Create New Survey"
                  className="btn-primary rounded-xl"
                  onClick={() =>
                    history.push({
                      pathname: `/create-survey`,
                      state: {
                        selectedTemplates,
                      },
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-white card px-11 py-9 relative rounded-lg"
          style={{ minHeight: "65vh", width: "38%" }}>
          <div>
            <div className="flex justify-between">
              <p className="font-bold text-lg text-primary">Survey Results</p>
            </div>
            {!isSurveyLoading ? (
              <div
                className={`mt-4 ${
                  surveyResults.length > 0 ? "overflow-y-auto" : ""
                }`}>
                <InfiniteScroll
                  hasMore={hasMoreRecords}
                  next={() => fetchMoreData()}
                  loader={<Loader />}
                  height="60vh"
                  dataLength={surveyResults.length}>
                  {surveyResults && surveyResults.length > 0 ? (
                    surveyResults.map((survey, index) => (
                      <div
                        className={`flex px-4 py-4 rounded-md bg-purple-100 mb-2 justify-around cursor-pointer`}
                        style={{
                          backgroundColor: "#EEFCF1",
                          border: "1px solid #9FDFAD",
                        }}
                        key={survey._id}
                        onClick={() => {
                          history.push({
                            pathname: `/survey-details`,
                            search: `?surveyId=${survey._id}`,
                          });
                        }}>
                        <div className="w-1/12">
                          <img src={surveyIconImg} />
                        </div>
                        <div className="w-10/12	 ml-3 ">
                          <div className="flex justify-between">
                            <div
                              className="text-sm t-grey font-bold whitespace-nowrap overflow-y-auto"
                              style={{ width: "60%" }}>
                              {survey.title}
                            </div>
                            <ol
                              className="list-disc p-0 t-grey flex flex-row-reverse"
                              style={{ width: "35%" }}>
                              <li className="text-xs">
                                {moment(survey.createdAt).fromNow()}
                              </li>
                            </ol>
                          </div>
                          <div className="overflow-y-auto h-8 overflow-x-hidden flex items-center justify-between">
                            <div
                              className="flex items-center"
                              style={{ width: "45%" }}>
                              <img
                                src={surveyCheckIcon}
                                className="survey-widget-img mr-1"
                              />
                              <span className="text-xs t-grey whitespace-nowrap overflow-y-auto">
                                {` ${survey.submittedUser} `} /
                                {` ${survey.allUsers} `} Completed{" "}
                              </span>
                            </div>
                            <div
                              className="text-right flex items-center justify-end"
                              style={{ width: "55%" }}>
                              <img
                                src={surveyCalendarIcon}
                                className="survey-widget-img mr-1"
                              />
                              <span className="text-xs t-grey whitespace-nowrap overflow-y-auto">
                                {`Due ${moment(survey.dueDate)
                                  .utc()
                                  .format("ddd MMMM DD")}`}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <p className="text-primary">Surveys Results not found</p>
                    </div>
                  )}
                </InfiniteScroll>
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const SurveyPage = withToast(
  connect((state) => ({
    user: state.auth,
  }))(SurveyPageComponent)
);

export default SurveyPage;
